import React, {useState} from 'react';
import {Button, Row, Col, Modal, Label, FormGroup} from 'reactstrap';
import {useForm} from 'react-hook-form';
import {SweetAlert} from '../Common/SweetAlert';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import authHeader from '../../helpers/jwt-token-access/auth-token-header';

const reasonList = [
  {label: 'Good will', value: 1},
  {label: '3 months', value: 2},
  {label: 'Other', value: 3},
];

const problemList = [{
  label: 'Mech:Maintenance unit broken',
  value: 'Mech:Maintenance unit broken',
}, {label: 'Mech:Cartridge broken', value: 'Mech:Cartridge broken'}, {
  label: 'Mech:Ink supply area broken',
  value: 'Mech:Ink supply area broken',
}, {label: 'Mech:Tube broken', value: 'Mech:Tube broken'}, {
  label: 'Mech:Platen broken',
  value: 'Mech:Platen broken',
}, {label: 'Mech:Cover broken', value: 'Mech:Cover broken'}, {
  label: 'Mech:Cariage broken',
  value: 'Mech:Cariage broken',
}, {label: 'Mech:Motor broken', value: 'Mech:Motor broken'}, {
  label: 'Mech:Other',
  value: 'Mech:Other',
}, {label: 'Head:Missing', value: 'Head:Missing'}, {
  label: 'Head:Angled Firing',
  value: 'Head:Angled Firing',
}, {label: 'Head:Both', value: 'Head:Both'}, {
  label: 'Head:CLP peeling off',
  value: 'Head:CLP peeling off',
}, {
  label: 'Head:Nozzle plate peeling off',
  value: 'Head:Nozzle plate peeling off',
}, {label: 'Head:Temp, voltage abnormal', value: 'Head:Temp, voltage abnormal'}, {
  label: 'Head:Other',
  value: 'Head:Other',
}, {label: 'App/Firm:Other', value: 'App/Firm:Other'}, {
  label: 'Ink:Ink pouch burst',
  value: 'Ink:Ink pouch burst',
}, {label: 'Ink:IC chip missing', value: 'Ink:IC chip missing'}, {
  label: 'Sub:Main PCB broken',
  value: 'Sub:Main PCB broken',
}, {label: 'Sub:Carriage PCB broken', value: 'Sub:Carriage PCB broken'}, {
  label: 'Sub:Ink Switch PCB broken',
  value: 'Sub:Ink Switch PCB broken',
}, {label: 'Sub:Other', value: 'Sub:Other'}, {label: 'Other:Other', value: 'Other:Other'}];

const ModalInternalCheck = ({claim}) => {
  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);

  const navigate = useNavigate();
  const {handleSubmit, register, watch} = useForm();

  const watchedReason = watch('reason_choice');
  const watchedStatus = watch('status');

  const toggleModal = () => setModal(!modal);

  const onSubmit = async (values) => {
    let reason = '';
    if (values.reason_choice === '3' && values.other_reason) {
      reason = values.other_reason;
    } else if (values.reason_choice) {
      const found = reasonList.find((r) => r.value === parseInt(values.reason_choice));
      reason = found ? found.label : '';
    }

    const internalCheck = {
      claim_id: claim.id,
      status: values.status,
      individual_reply: values.status === '3' ? (values.individual_reply || '') : '',
      reason_choice: values.reason_choice || '',
      reason: reason || '',
      problem_type: values.problem_type || '',
    };

    setIsLoading(true);

    try {
      const url = `${process.env.REACT_APP_APIURL}claim/internalcheck`;
      const authToken = authHeader();
      const formData = new FormData();
      formData.append('data', JSON.stringify(internalCheck));
      await axios.post(url, formData, {headers: authToken});
      setIsLoading(false);
      setSuccessMsg(true);
    } catch (err) {
      setIsLoading(false);
      setErrorMsg(true);
    }
  };

  return (
    <>
      <Button color="dark" onClick={toggleModal}>Internal Check</Button>

      <Modal size="lg" isOpen={modal} toggle={toggleModal} centered>
        <div className="modal-body">
          <button type="button" onClick={toggleModal} className="close">
            <span aria-hidden="true">&times;</span>
          </button>
          <Row>
            <Col md={1}>
              <div className="avatar-sm">
                <span className="avatar-title rounded-circle bg-primary text-white">
                  <i className="bx bx-check-circle bx-sm"/>
                </span>
              </div>
            </Col>
            <Col md={11}>
              <h5 className="modal-title mt-0">Internal Check</h5>
              <p>Please choose from the following cases</p>

              <form onSubmit={handleSubmit(onSubmit)}>
                <Row className={'mb-3'}>
                  <Col>
                    <input
                      type="radio"
                      value="1"
                      {...register('status', {
                        required: true,
                      })}
                    /> Warranty accepted
                  </Col>
                  <Col>
                    <input
                      type="radio"
                      value="2"
                      {...register('status', {
                        required: true,
                      })}
                    /> Internal accepted
                  </Col>
                  <Col>
                    <input
                      type="radio"
                      value="3"
                      {...register('status', {
                        required: true,
                      })}
                    /> Warranty not granted
                  </Col>
                </Row>

                {watchedStatus && (
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="col-form-label">Customer</Label>
                        <input type="text" value={claim.customer?.name || ''} disabled className="form-control"/>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label className="col-form-label">Dealer</Label>
                        <input type="text" value={claim.dealer?.name || ''} disabled className="form-control"/>
                      </FormGroup>
                    </Col>
                    {watchedStatus === '1' && (
                      <Col md={6}>
                        <Label className="col-form-label">Problem</Label>
                        <select {...register('problem_type', {
                          required: true,
                        })} className="form-control">
                          <option value="">Select problem</option>
                          {problemList.map((p, i) => <option key={i} value={p.value}>{p.label}</option>)}
                        </select>
                      </Col>
                    )}
                    {watchedStatus === '2' && (
                      <Col md={6}>
                        <Label className="col-form-label">Reason</Label>
                        <select {...register('reason_choice')} className="form-control">
                          <option value="">Select reason</option>
                          {reasonList.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
                        </select>
                        {watchedReason === '3' && (
                          <input {...register('other_reason')} type="text" className="form-control mt-2"
                            placeholder="Other reason"/>
                        )}
                      </Col>
                    )}
                    {watchedStatus === '3' && (
                      <Col md={12}>
                        <Label className="col-form-label">Message</Label>
                        <textarea
                          {...register('individual_reply')}
                          className="form-control"
                          rows={5}
                          defaultValue={['bma'].includes(process.env.REACT_APP_REALM) ?
                            `Dear ${claim.engineer.firstname} ${claim.engineer.lastname},\n\nWe checked the parts and we have unfortunately inform you that we are unable to confirm your claim. Should you require further information please do not hesitate to contact us via e-mail to ipb-support@brother-ism.com. Please use the Fault Report Number in the subject.` :
                            `Dear ${claim.engineer.firstname} ${claim.engineer.lastname},\n\nWe checked the parts and we have unfortunately inform you that we are unable to confirm your claim.\nShould you require further information do not hesitate to contact us via e-mail.\nPlease use the Fault Report Number in the subject.`}
                        />
                      </Col>
                    )}
                  </Row>
                )}

                <Row className="mt-2">
                  <Col md={8}>
                    <p>
                      After the submission, a technical manager will be informed. He must finally confirm and close the
                      claim.
                    </p>
                  </Col>
                  <Col md={4} className="text-right">
                    <Button type="submit" color="dark" disabled={isLoading}>
                      {isLoading ? <i className="bx bx-loader bx-spin mr-2"/> : null}
                      Submit for approval
                    </Button>
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
        </div>
      </Modal>

      {successMsg && (
        <SweetAlert
          title="Good job!"
          success
          onConfirm={() => {
            setSuccessMsg(false);
            navigate('/claims');
          }}
        >
          Internal check was submitted successfully and is now in review by our team.
        </SweetAlert>
      )}
      {errorMsg && (
        <SweetAlert
          title="Request could not be submitted!"
          warning
          onConfirm={() => setErrorMsg(false)}
        >
          There was an error while submitting your request. Please try again.
        </SweetAlert>
      )}
    </>
  );
};

export default ModalInternalCheck;
